import styled from 'styled-components';

export const StyledFeatureGuideSidebar = styled.aside`
    width: 325px;
`;

export const StyledFeatureGuidePagination = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    button:not(:disabled) {
        color: var(--brand-6);
    }
`;
